// portfolio images
import ArtGhettodMain from '../assets/images/ArtGhettoMain.webp';
import ChaterioMain from '../assets/images/Chaterio_1.webp';
import LearnScotlandMain from '../assets/images/LearnScotland.webp';
import RecipeAIMain from '../assets/images/RecipeAI.webp';
import WeatherMain from '../assets/images/WeatherwiseMain.webp';
import WatchlistMain from '../assets/images/watchlist.webp';
import MapMain from '../assets/images/map.webp';
import Service from '../assets/images/ServiceCapture.webp'
// carousel images
import ArtGhettoOne from '../assets/images/ArtGhetto_2.webp';
import ArtGhettoTwo from '../assets/images/ArtGhetto_3.webp';
import ArtGhettoThree from '../assets/images/ArtGhetto_4.webp';
import ChaterioOne from '../assets/images/imagescomingsoon.webp';
import ChaterioTwo from '../assets/images/imagescomingsoon.webp';
import ChaterioThree from '../assets/images/imagescomingsoon.webp';
import WatchlistOne from '../assets/images/watchlistmovies.webp';
import WatchlistTwo from '../assets/images/watchlistmovie.webp';
import WatchlistThree from '../assets/images/watchlistdirector.webp';
import WeatherOne from '../assets/images/WeatherwiseWeather.webp';
import WeatherTwo from '../assets/images/WeatherwiseSearch.webp';
import WeatherThree from '../assets/images/WeatherwiseFavs.webp';
import MapOne from '../assets/images/map1.webp';
import MapTwo from '../assets/images/map2.webp';
import MapThree from '../assets/images/map3.webp';
import ServiceTwo from '../assets/images/ServiceCapture2.webp'
import ServiceThree from '../assets/images/ServiceCapture3.webp'
import ServiceFour from '../assets/images/ServiceCapture4.webp'
// carousel videos
import LearnScotlandVideo from '../assets/videos/LearnScotland.mp4';
import RecipeAIVideo from '../assets/videos/RecipeAI.mp4';
// technology icons
import ASPnet from '../assets/techImages/aspnet.png';
import Bootstrap from '../assets/techImages/bootstrap.png';
import CSharp from '../assets/techImages/csharp.png';
// import CSS from '../assets/techImages/css.png';
import Expo from '../assets/techImages/expo.png';
import Django from '../assets/techImages/django.png';
import Flask from '../assets/techImages/flask.png';
import Git from '../assets/techImages/git.png';
import GitHub from '../assets/techImages/github.png';
// import HTML from '../assets/techImages/html.png';
import Java from '../assets/techImages/java.png';
import JavaScript from '../assets/techImages/javascript.png';
import Mongo from '../assets/techImages/mongodb.png';
import Nodejs from '../assets/techImages/nodejs.png';
import NPM from '../assets/techImages/npm.png';
import PostgreSQL from '../assets/techImages/postgresql.png';
import Python from '../assets/techImages/python.png';
// import Reactjs from '../assets/techImages/reactjs.png';
import Reactjs from '../assets/techImages/react.webp';
import ReactNative from '../assets/techImages/reactnative.png';
import SpringBoot from '../assets/techImages/springboot.png';
import StyledComponents from '../assets/techImages/styledcomponents.png';
import Threejs from '../assets/techImages/threejs.svg';
import TypeScript from '../assets/techImages/typescript.png';
import Lambda from '../assets/techImages/awslambda.png';
import Dynamo from '../assets/techImages/awsdynamodb.png';
import Gateway from '../assets/techImages/awsgateway.png';
import IAM from '../assets/techImages/awsiam.png';
import CDK from '../assets/techImages/awscdk.png';
import EventBridge from '../assets/techImages/awseventbridge.png';
import SES from '../assets/techImages/awsses.png';


const navlinks = [
    {
        id: "about",
        title: "About",
    },
    {
        id: "training",
        title: "Training",
    },
    {
        id: "skills",
        title: "Skills",
    },
    {
        id: "experience",
        title: "Experience",
    },
    {
        id: "portfolio",
        title: "Portfolio",
    },
    {
        id: "contact",
        title: "Contact",
    },
]


const about = [
   "I am a full-stack software developer with experience building and maintaining production web and mobile applications across frontend, backend, and cloud infrastructure. My work focuses on API-driven architecture, serverless AWS solutions, and cross-platform mobile development.\n\nMost recently, I designed and built Service Capture, a SaaS application available on the Apple App Store and Google Play, created for trades and service professionals to document work, generate PDF reports, and manage proof-of-work records.\n\nPrior to transitioning into software development, I spent over 10 years in accounts and administration and 5 years teaching English abroad. These roles strengthened my communication skills, attention to detail, problem-solving ability, and confidence collaborating with clients and teams in fast-paced environments."
]

const experiences = [
{
    title: 'Software Developer',
    description: "Professional, freelance, and volunteer software development experience across web, mobile, and cloud-based systems.",
    skills: [
        "TypeScript & JavaScript",
        "React & React Native",
        "API integrations & automation",
        "AWS serverless architecture",
        "Agile collaboration & problem solving",
    ]
},
    {
        title: 'English Language Instructor',
        description: "Over 5 years teaching English as second language in South Korea, Vietnam, and online.",
        skills: [
            "Interpersonal communication",
            "PowerPoint presentations",
            "Planning & organising",
            "Leadership",
            "Relationship building",
        ]
    },
    {
        title: 'Accounts and Administration',
        description: "10+ years working within accounting departments across variety of sectors.",
        skills: [
            "Attention to detail",
            "Problem solving & Analysis",
            "Teamwork & independent work",
            "Streamlining workflows",
            "Strong Excel & reporting",
        ]
    },
]

const skills = [
    {
        name: "TypeScript",
        icon: TypeScript
    },
     {
        name: "React Native",
        icon: ReactNative
    },
    {
        name: "Expo",
        icon: Expo
    },
    {
        name: "React JS",
        icon: Reactjs
    },
    {
        name: "JavaScript",
        icon: JavaScript
    },
    {
        name: "Node JS",
        icon: Nodejs
    },
        {
        name: "AWS Lambda",
        icon: Lambda
    },
    {
        name: "AWS DynamoDB",
        icon: Dynamo
    },
    {
        name: "AWS API Gateway",
        icon: Gateway
    },
    {
        name: "AWS IAM",
        icon: IAM
    },
    {
        name: "AWS CDK",
        icon: CDK
    },
    {
        name: "AWS EventBridge",
        icon: EventBridge
    },
    {
        name: "AWS SES",
        icon: SES
    },

    {
        name: "Python",
        icon: Python
    },
    {
        name: "Java",
        icon: Java
    },
    {
        name: "C#",
        icon: CSharp
    },
    {
        name: "Django",
        icon: Django
    },
    {
        name: "Flask",
        icon: Flask
    },
    {
        name: "Spring Boot",
        icon: SpringBoot
    },
    {
        name: "ASP.NET",
        icon: ASPnet
    },
    {
        name: "Threejs",
        icon: Threejs
    },
    {
        name: "PostgreSQL",
        icon: PostgreSQL
    },
    {
        name: "MongoDB",
        icon: Mongo
    },
    {
        name: "Styled-Components",
        icon: StyledComponents
    },
    {
        name: "Bootstrap",
        icon: Bootstrap
    },
    {
        name: "npm",
        icon: NPM
    },
    {
        name: "Git",
        icon: Git
    },
    {
        name: "GitHub",
        icon: GitHub
    },

]

const projects = [
    {
        title: "Service Capture",
        subtitle: "Cross-platform SaaS product available on the Apple App Store and Google Play",
        paragraph: "Job documentation and proof-of-work app designed for trades and service professionals. It enables users to capture photos during appointments, attach them directly to jobs, and generate professional PDF reports that can be shared with clients.",
        technologies: "React Native / Expo / TypeScript / AWS Serverless",
        githublink: null,
        website: "https://servicecapture.app",
        modalNumber: 1,
        isVideo: false,
        imageMain: Service,
        imageOne: ServiceThree, 
        imageTwo: ServiceTwo,
        imageThree: ServiceFour,
    },
    {
        title: "WeatherWise",
        subtitle: "CS50W Web Programming with Python and JavaScript from HarvardX",
        paragraph: "Fully responsive Weather app for a user to search 45,000 cities and get 24 hour and 10 day weather forecasts. Includes a My Locations dashboard with local timezones.",
        technologies: "Python / Django / React / SQlite",
        githublink: "https://github.com/dvdjms/CS50w_Capstone",
        website: null,
        modalNumber: 2,
        isVideo: false,
        imageMain: WeatherMain,
        imageOne: WeatherOne, 
        imageTwo: WeatherTwo,
        imageThree: WeatherThree,
    },
    {
        title: "Learn Scotland",
        subtitle: "CodeClan Group Project",
        paragraph: "Working within a group of four, we planned, designed, and developed a Learn Scotland application aimed at young people. This included quizzes, interactive activities, and a leaderboard.",
        technologies: "React / ExpressJS / MongoDB",
        githublink: "https://github.com/dvdjms/Learn_Scotland",
        website: null,
        modalNumber: 3,
        isVideo: true,
        video: LearnScotlandVideo,
        imageMain: LearnScotlandMain,
    },
    {
        title: "Recipe AI",
        subtitle: "Angular, C#, and ChatGPT Practice Project",
        paragraph: "Intrigued by the rapid evolution of Artificial Intelligence, I couldn't resist the urge to dive into the ChatGPT API. To channel my focus, I embarked on building a recipe generator.",
        technologies: "Angular / ASP.NET",
        githublink: "https://github.com/dvdjms/Recipe-AI",
        website: null,
        modalNumber: 4,
        isVideo: true,
        video: RecipeAIVideo,
        imageMain: RecipeAIMain,
    },
    {
        title: "Movie Watchlist",
        subtitle: "CodeClan Individual Project",
        paragraph: "After 4 weeks at CodeClan we undertook our first project. Working independently we were to create a Flask application that allows a user to perform simple CRUD actions. I created a movie watchlist.",
        technologies: "Python / Flask / PostgreSQL",
        githublink: "https://github.com/dvdjms/watchlist",
        website: null,
        modalNumber: 5,
        isVideo: false,
        imageOne: WatchlistOne,
        imageTwo: WatchlistTwo,
        imageThree: WatchlistThree,
        imageMain: WatchlistMain,
    },
    {
        title: "Art Ghetto",
        subtitle: "CS50x Final Project",
        paragraph: "Working independently, I developed a Flask application that allows user to simulate buying art. A user can register, a user can buy art, a user can view transaction history.",
        technologies: "Python / Flask / JavaScript / Sqlite3",
        githublink: "https://github.com/dvdjms/Art-Ghetto",
        website: null,
        modalNumber: 6,
        isVideo: false,
        imageOne: ArtGhettoOne,
        imageTwo: ArtGhettoTwo,
        imageThree: ArtGhettoThree,
        imageMain: ArtGhettodMain,
    },
    {
        title: "Chaterio",
        subtitle: "CodeClan Capstone Project",
        paragraph: "For the final project at CodeClan, I worked independently to explore WebSocket technologies for a video chat application. Ambitious to say the least!",
        technologies: "React / ExpressJS / WebSockets",
        githublink: "https://github.com/dvdjms/Capstone",
        website: null,
        modalNumber: 7,
        isVideo: false,
        imageOne: ChaterioOne,
        imageTwo: ChaterioTwo,
        imageThree: ChaterioThree,
        imageMain: ChaterioMain,
    },
    {
        title: "Scottish Tech Army",
        subtitle: "Volunteer software development project",
        paragraph: "Automated website updates using Jira APIs. Focused on updating project information and pinning project geo locations.",
        technologies: "JavaScript / Google Maps / AWS Lambda",
        githublink: "https://github.com/dvdjms/STA_Map_Project",
        website: null,
        modalNumber: 8,
        isVideo: false,
        imageOne: MapOne,
        imageTwo: MapTwo,
        imageThree: MapThree,
        imageMain: MapMain,
    },
];


const training = {
    codeclan: [
        "Python with Flask", "JavaScript", "Java with Spring Boot", "RESTful APIs", "PostreSQL & MongoDB",
        "Test Driven Development", "Agile Methodologies", "Pair-Programming", "SQA Accredited"
    ],
    cs50: [
        "C Programming", "Python with Django", "JavaScript", "Bootstrap",
        "SQL", "Database design", "Scalability", "Security", "Certificate"
    ],
};

export { navlinks, about, experiences, skills, projects, training};